import { Component, Input } from '@angular/core';

export type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;
export type HeadingAppearance = 'inherit' | 'h1' | 'h2' | 'h3' | 'h4';

/**
 * Semantic heading with optional visual appearance override.
 * Use [label] — do not project content into @switch (ng-content will not render).
 */
@Component({
  selector: 'app-heading',
  imports: [],
  template: `
    @switch (level) {
      @case (1) {
        <h1 [attr.id]="id" [attr.tabindex]="tabindex" [class]="headingClass">
          {{ label }}
        </h1>
      }
      @case (2) {
        <h2 [attr.id]="id" [attr.tabindex]="tabindex" [class]="headingClass">
          {{ label }}
        </h2>
      }
      @case (3) {
        <h3 [attr.id]="id" [attr.tabindex]="tabindex" [class]="headingClass">
          {{ label }}
        </h3>
      }
      @case (4) {
        <h4 [attr.id]="id" [attr.tabindex]="tabindex" [class]="headingClass">
          {{ label }}
        </h4>
      }
      @case (5) {
        <h5 [attr.id]="id" [attr.tabindex]="tabindex" [class]="headingClass">
          {{ label }}
        </h5>
      }
      @case (6) {
        <h6 [attr.id]="id" [attr.tabindex]="tabindex" [class]="headingClass">
          {{ label }}
        </h6>
      }
    }
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
})
export class HeadingComponent {
  @Input({ required: true })
  level!: HeadingLevel;

  @Input({ required: true })
  label!: string;

  @Input()
  appearance: HeadingAppearance = 'inherit';

  @Input()
  id?: string;

  @Input()
  tabindex?: number | null;

  /** Extra Tailwind / utility classes on the heading element. */
  @Input()
  classes?: string;

  protected get headingClass(): string | null {
    const parts: string[] = [];
    if (this.appearance && this.appearance !== 'inherit') {
      parts.push(`heading-appearance-${this.appearance}`);
    }
    if (this.classes) {
      parts.push(this.classes);
    }
    return parts.length ? parts.join(' ') : null;
  }
}
